export const canChangeTankStatus = (role) => role === 'ADMIN';
